<template>
  <div class="visual-calendar" @click="editDate($event)">
    <input ref="cal" type="text" style="display:none;z-index:10005;position:relative;">
    <div class="top">
      <img class="f-w" src="/images/calendar-top.png" alt="">
      <span>{{ month }}</span>
    </div>
    <div class="bottom">
      <img class="f-w" src="/images/calendar-bottom.png" alt="">
      <span :style="bottomTextStyle">{{ day }}</span>
    </div>
  </div>
</template>

<script>
/**
 * Vintage red / white calendar to edit a date
 * v-model: date object
 */

import $ from 'jquery';

export default {
  name: 'VisualCalendar',

  props: {
    value: {
      type: String,
      default: '',
    },
    highlight: {
      type: String,
      default: '',
    },
    disabled: Boolean,
  },

  data() {
    return {
    };
  },

  computed: {
    month() {
      if (this.value) {
        const date = this.$moment(this.value);
        return date.isValid() ? date.format('MMM') : '???';
      }
      return '???';
    },
    day() {
      if (this.value) {
        const date = this.$moment(this.value);
        return date.isValid() ? date.format('DD') : '?';
      }
      return '?';
    },
    /** Boolean: true if the text of the bottom section should be highlighted */
    shouldHighlight() {
      return this.highlight && this.highlight.length;
    },
    /** Object: Style of the text over the white section of the calendar */
    bottomTextStyle() {
      return {
        color: this.shouldHighlight ? this.highlight : undefined,
        fontWeight: this.shouldHighlight ? '650' : undefined,
      };
    },
  },

  beforeDestroy() {
    $(this.$refs.cal).datepicker('destroy');
  },

  methods: {
    editDate() {
      if (this.disabled) {
        return;
      }
      $(this.$refs.cal).datepicker({
        showButtonPanel: true,
        showOtherMonths: true,
        selectOtherMonths: true,
        nextText: this.$t('message.NEX'),
        prevText: this.$t('message.PREV'),
        currentText: this.$t('message.TODAY_SHORT'),
        closeText: this.$t('message.DONE'),
        onSelect: (dateText, inst) => {
          this.$emit(
            'input',
            inst.selectedYear
              + (inst.selectedMonth < 9 ? '-0' : '-') + (inst.selectedMonth + 1)
              + (inst.selectedDay < 10 ? '-0' : '-') + inst.selectedDay,
          );
        },
        beforeShow: () => {
          // Above navigation
          // NOTE this fix is temporary and is relevant only for the old design
          // Timeout is mandatory to make sure the component is properly displayed
          setTimeout(() => {
            $('.ui-datepicker').css('z-index', 100200);
          }, 0);
        },
      });
      $(this.$refs.cal).datepicker('show');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.visual-calendar {
  &.inline {
    display: inline-block;
  }
  &, .top, .bottom {
    position: relative;
    width: 36px;
    margin: auto;
  }
  img {
    display: block;
    filter: drop-shadow(2px 2px 3px #b4b4b4);
  }
  span {
    position: absolute;
    font-size: 0.75em;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 600;
    line-height: initial;
  }
  .top span {
    color: #ffffff;
    bottom: 0px;
  }
  .bottom span {
    top: 5px;
  }
}

@media (max-width: $smartphone-landscape) {
  .visual-calendar {
    &, .top, .bottom {
      width: 30px;
    }
    .bottom span {
      top: 3px;
    }
  }
}
</style>
